/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit LastModified/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function LastModified({
  children,
  viewPath = "/App/Account/Content/Settings/Content/CommsEmail/Emails/Emails/Content/Email/LastModified"
  
}) {
let dtColorsNeutral500 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.500'
        })
let emailLastUpdatedUpdatedByValueData = fromData.useDataValue({ viewPath,
context: 'email',
path: 'last_updated.updated_by',
})
let emailLastUpdatedUpdatedAtValueData = fromData.useDataFormat({ viewPath,
context: 'email',
path: 'last_updated.updated_at',
format: fromHelpers.format,
})
  return (<React.Fragment
>
<div
  data-testid="LastModified.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 color={dtColorsNeutral500}
 text="Last modified by"
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 data="email.last_updated.updated_by"
 text={emailLastUpdatedUpdatedByValueData}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 color={dtColorsNeutral500}
 text="on"
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 data="email.last_updated.updated_at"
 format="helpers.js format"
 text={emailLastUpdatedUpdatedAtValueData}
/>
</div>
{children}
</React.Fragment>)
}